import { observable } from 'mobx'
import api from '../api'

export default class BillingStore {
  @observable customer
  @observable license

  loadCustomer() {
    return api.get('billing').then(({ data:customer }) => { this.customer = customer })
  }

  loadLicense() {
    return api.get('license').then(({ data:license }) => { if (license) this.license = license[0] })
  }

  activateSubscription(token , billing_address = {}) {
    return api.post(`license/${this.license.id}/activate_subscription`, { token , billing_address })
  }

  updateAddress(data) {
    return api.post(`billing/update_address`, data)
  }

  doUpgrade() {
    // TODO remove this
    // Right now a user can only upgrade a plan.
    // In the future we will want them to be able to change their plan however they want
    // This method will be unneeded then.
    return this.updateLicense({ plan: `premium_${this.license.rate}_APR26` })
  }

  updateSource(token) {
    return api.put('billing', { token }).then(() => this.loadCustomer())
  }

  updateLicense(params) {
    return api.put(`license/${this.license.id}`, params).then(() => this.loadLicense())
  }

  apply_2to3_discount() {
    return api.post(`license/${this.license.id}/apply_2to3_discount`).then(() => this.loadLicense())
  }
}



// WEBPACK FOOTER //
// client/stores/billing.js